import React from "react";
import PropTypes from "prop-types";
import { NavItem, NavLink } from "shards-react";

const SidebarNavItemOpener = ({ item, onClick, isOpen }) => (
  <NavItem>
    <NavLink onClick={() => onClick()} style={{cursor: 'pointer'}}>
      {item.htmlBefore && (
        <div
          className="d-inline-block item-icon-wrapper"
          dangerouslySetInnerHTML={{ __html: item.htmlBefore }}
        />
      )}
      {item.title && <span>{item.title}</span>}
      <span className="ml-auto">
        <i className={`material-icons ${isOpen ? 'rotate-icon' : ''}`} style={{transition: 'transform .3s'}}>
          expand_more
        </i>
      </span>
      {item.htmlAfter && (
        <div
          className="d-inline-block item-icon-wrapper"
          dangerouslySetInnerHTML={{ __html: item.htmlAfter }}
        />
      )}
    </NavLink>
  </NavItem>
);

SidebarNavItemOpener.propTypes = {
  /**
   * The item object.
   */
  item: PropTypes.object,
  /**
   * Click handler.
   */
  onClick: PropTypes.func,
  /**
   * Whether the sub-menu is open.
   */
  isOpen: PropTypes.bool
};

SidebarNavItemOpener.defaultProps = {
  isOpen: false
};

export default SidebarNavItemOpener;
